import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import { ContainerSearch, TextFieldStyled } from "./style";

interface ILayoutBasePageProps {
  placeholder: string;
  disabled?: boolean;
  // name: string;
  changeTextSearch: (novoTexto: string) => void;
}

export const PageSearch = ({
  disabled,
  placeholder,
  // name,
  changeTextSearch,
}: ILayoutBasePageProps) => {
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    // Limpa o state se altera o placeholder
    setSearch("");
  }, [placeholder]);

  useEffect(() => {
    changeTextSearch(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <ContainerSearch>
      <TextFieldStyled
        size="small"
        fullWidth
        // name={name}
        autoComplete="no"
        value={search}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        sx={{
          backgroundColor: "transparent",
          borderRadius: "5px",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                sx={{ color: "white" }}
              />
            </InputAdornment>
          ),
        }}
      />
    </ContainerSearch>
  );
};
